import React, { memo } from 'react';

import style from './style.module.css';

const TagRemindersComponent = ({ hide, message }) => (!hide ? <div className={style.host}>{message}</div> : null);

export const TagReminders = memo(TagRemindersComponent);
